<template>
<div>
  <BListGroup
    flush
  >
    <BListGroupItem
      :key="fee.id"
      v-for="fee in filterFees(fees, displayAll)"
    >
      <ItpBox>
        <span
          class="mr-2"
        >
          •
        </span>
        <ItpBox>
          <ItpText>
            <ItpText>{{ fee.valid_from|date }}</ItpText>
<ItpText v-if="fee.valid_to"> - {{ fee.valid_to|date }}</ItpText>

<ItpText class="px-3">
  <span v-if="fee.quantity != null">
    {{ fee.quantity|number }} {{ fee.unit_of_quantity || '' }} &times;
  </span>
   {{ fee.amount|number }} {{ fee.currency }} [{{ fee.unit }}]
</ItpText>

          </ItpText>
          <ItpText
            :text="fee.notes"
            pre
            v-if="fee.notes"
          >
          </ItpText>
        </ItpBox>
        <ItpButton
          icon="fa-pen"
          :tooltip="'Edit'|gettext"
          variant="light"
          size="sm"
          v-if="!readonly"
          @click.prevent.stop="evh_6705964765214521_clickPreventStop($event, {fee})"
        >
        </ItpButton>
      </ItpBox>
    </BListGroupItem>
  </BListGroup>
  <ItpBox
    class="pl-4"
  >
    <ItpLink
      :text="'Show less'|gettext"
      v-if="canHideItems"
      @click.prevent.stop="evh_96700093353179_clickPreventStop($event, {})"
    >
    </ItpLink>
    <ItpLink
      :text="'Show more'|gettext"
      v-if="canDisplayMoreItems"
      @click.prevent.stop="evh_5974459770896956_clickPreventStop($event, {})"
    >
    </ItpLink>
    <ItpButton
      :text="'Add service fee...'|pgettext('Contract')"
      variant="light"
      size="sm"
      v-if="!readonly"
      @click.prevent.stop="evh_8852205820859826_clickPreventStop($event, {})"
    >
    </ItpButton>
  </ItpBox>
</div>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcContractServiceFees extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  mapFees(...args: any[]) {
    return _
      .chain(args[0])
      .orderBy(['valid_from', 'valid_to'], ['desc', 'desc'])
      .map((item, index, arr) => {
        const
          future = item.valid_from > this.$fn.today,
          current = !future && (index == 0 || arr[index - 1].valid_from > this.$fn.today),
          stale = !future && !current;

        return { item, future, current, stale }
      })
      .value();
  }

  filterFees(...args: any[]) {
    const [fees, displayAll] = args;
    return _
      .filter(fees, p => displayAll || p.future || p.current)
      .map(p => p.item);
  }

  @Prop({
    required: true,
    type: Object,
  })
  contract!: object;

  @Watch('contract')
  onContract(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("contract")
  }

  @Prop({
    required: true,
    type: Object,
  })
  service!: object;

  @Watch('service')
  onService(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("service")
  }

  @Prop({
    type: Boolean,
  })
  readonly!: boolean;

  @Watch('readonly')
  onReadonly(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("readonly")
  }

  today!: any;

  async $$load_today() {
    return new Date()
  }

  displayAll!: any;
  fees!: any;

  async $$load_fees() {
    return this.mapFees(this.service.fees)
  }

  hasStaleItems!: any;

  async $$load_hasStaleItems() {
    return _.some(this.fees, { stale: true })
  }

  ux!: any;
  dataMembers = ['today', 'displayAll', 'fees', 'hasStaleItems', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        today: null,
        displayAll: false,
        fees: null,
        hasStaleItems: null,
        ux: null,
      },
    }
  }

  get canDisplayMoreItems() {
    if (this.loaded) {

      return !this.displayAll && this.hasStaleItems
    }
    return null;
  }

  get canHideItems() {
    if (this.loaded) {

      return this.displayAll && this.hasStaleItems
    }
    return null;
  }

  async act_6705964765214521_emit_8896_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_6705964765214521_emit_8896, alias=emitReload
    return {
      event: "reload",
    }
  }

  async evh_6705964765214521_close_8895_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_6705964765214521_close_8895, alias=undefined
    return !!$event.data.modalResult.ok
  }

  async act_6705964765214521_showModal_8894_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_6705964765214521_showModal_8894, alias=undefined
    return {
      name: "ContractServiceEditor",
      props: {
        mode: "editServiceFee",
        contract: this.contract,
        service: _.cloneDeep(this.service),
        fee: _.cloneDeep($event.scope.fee),
      }
      ,
    }
  }

  async evh_6705964765214521_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6705964765214521_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_96700093353179_setData_8898_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_96700093353179_setData_8898, alias=undefined
    return {
      path: "displayAll",
      value: false,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_96700093353179_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_96700093353179_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_5974459770896956_setData_8900_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_5974459770896956_setData_8900, alias=undefined
    return {
      path: "displayAll",
      value: true,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_5974459770896956_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5974459770896956_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_8852205820859826_emit_8904_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_8852205820859826_emit_8904, alias=emitReload
    return {
      event: "reload",
    }
  }

  async evh_8852205820859826_close_8903_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_8852205820859826_close_8903, alias=undefined
    return !!$event.data.modalResult.ok
  }

  async act_8852205820859826_showModal_8902_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_8852205820859826_showModal_8902, alias=undefined
    return {
      name: "ContractServiceEditor",
      props: {
        mode: "addServiceFee",
        contract: this.contract,
        service: _.cloneDeep(this.service),
      }
      ,
    }
  }

  async evh_8852205820859826_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8852205820859826_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_6705964765214521_emit_8896: actions.EmitAction;
    evh_6705964765214521_close_8895: actions.EventHandlerImpl;
    act_6705964765214521_showModal_8894: actions.ShowModalAction;
    evh_6705964765214521_clickPreventStop_8893: actions.EventHandlerImpl;
    evh_6705964765214521_clickPreventStop: actions.EventHandlerGroup;
    act_96700093353179_setData_8898: actions.SetDataAction;
    evh_96700093353179_clickPreventStop_8897: actions.EventHandlerImpl;
    evh_96700093353179_clickPreventStop: actions.EventHandlerGroup;
    act_5974459770896956_setData_8900: actions.SetDataAction;
    evh_5974459770896956_clickPreventStop_8899: actions.EventHandlerImpl;
    evh_5974459770896956_clickPreventStop: actions.EventHandlerGroup;
    act_8852205820859826_emit_8904: actions.EmitAction;
    evh_8852205820859826_close_8903: actions.EventHandlerImpl;
    act_8852205820859826_showModal_8902: actions.ShowModalAction;
    evh_8852205820859826_clickPreventStop_8901: actions.EventHandlerImpl;
    evh_8852205820859826_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_6705964765214521_emit_8896 = new actions.EmitAction(
      {
        actionArgs: this.act_6705964765214521_emit_8896_getActionArgs,
        displayName: "emitReload",
        events: [],
      }
    );
    const evh_6705964765214521_close_8895 = new actions.EventHandlerImpl(
      {
        action: act_6705964765214521_emit_8896,
        event: "close",
        when: this.evh_6705964765214521_close_8895_getWhen,
        displayName: "emitReload",
      }
    );
    const act_6705964765214521_showModal_8894 = new actions.ShowModalAction(
      {
        actionArgs: this.act_6705964765214521_showModal_8894_getActionArgs,
        events: [evh_6705964765214521_close_8895],
      }
    );
    const evh_6705964765214521_clickPreventStop_8893 = new actions.EventHandlerImpl(
      {
        action: act_6705964765214521_showModal_8894,
        event: "click.prevent.stop",
        displayName: "showModal",
      }
    );
    const evh_6705964765214521_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_6705964765214521_clickPreventStop_8893],
      }
    );
    const act_96700093353179_setData_8898 = new actions.SetDataAction(
      {
        actionArgs: this.act_96700093353179_setData_8898_getActionArgs,
        events: [],
      }
    );
    const evh_96700093353179_clickPreventStop_8897 = new actions.EventHandlerImpl(
      {
        action: act_96700093353179_setData_8898,
        event: "click.prevent.stop",
        displayName: "setData",
      }
    );
    const evh_96700093353179_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_96700093353179_clickPreventStop_8897],
      }
    );
    const act_5974459770896956_setData_8900 = new actions.SetDataAction(
      {
        actionArgs: this.act_5974459770896956_setData_8900_getActionArgs,
        events: [],
      }
    );
    const evh_5974459770896956_clickPreventStop_8899 = new actions.EventHandlerImpl(
      {
        action: act_5974459770896956_setData_8900,
        event: "click.prevent.stop",
        displayName: "setData",
      }
    );
    const evh_5974459770896956_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_5974459770896956_clickPreventStop_8899],
      }
    );
    const act_8852205820859826_emit_8904 = new actions.EmitAction(
      {
        actionArgs: this.act_8852205820859826_emit_8904_getActionArgs,
        displayName: "emitReload",
        events: [],
      }
    );
    const evh_8852205820859826_close_8903 = new actions.EventHandlerImpl(
      {
        action: act_8852205820859826_emit_8904,
        event: "close",
        when: this.evh_8852205820859826_close_8903_getWhen,
        displayName: "emitReload",
      }
    );
    const act_8852205820859826_showModal_8902 = new actions.ShowModalAction(
      {
        actionArgs: this.act_8852205820859826_showModal_8902_getActionArgs,
        events: [evh_8852205820859826_close_8903],
      }
    );
    const evh_8852205820859826_clickPreventStop_8901 = new actions.EventHandlerImpl(
      {
        action: act_8852205820859826_showModal_8902,
        event: "click.prevent.stop",
        displayName: "showModal",
      }
    );
    const evh_8852205820859826_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_8852205820859826_clickPreventStop_8901],
      }
    );
    return {
      act_6705964765214521_emit_8896,
      evh_6705964765214521_close_8895,
      act_6705964765214521_showModal_8894,
      evh_6705964765214521_clickPreventStop_8893,
      evh_6705964765214521_clickPreventStop,
      act_96700093353179_setData_8898,
      evh_96700093353179_clickPreventStop_8897,
      evh_96700093353179_clickPreventStop,
      act_5974459770896956_setData_8900,
      evh_5974459770896956_clickPreventStop_8899,
      evh_5974459770896956_clickPreventStop,
      act_8852205820859826_emit_8904,
      evh_8852205820859826_close_8903,
      act_8852205820859826_showModal_8902,
      evh_8852205820859826_clickPreventStop_8901,
      evh_8852205820859826_clickPreventStop,
      emitReload: act_8852205820859826_emit_8904,
    }
  }
}

Vue.component("UcContractServiceFees", UcContractServiceFees);

</script>